var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommerceEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 752 752",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200,900) scale(0.15,-0.15)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5170 5710 c-30 -11 -77 -36 -105 -55 -27 -19 -320 -305 -650 -635     l-600 -601 55 -47 c192 -165 314 -286 497 -497 l52 -60 619 620 c579 579 622     625 653 690 32 66 34 76 34 180 0 103 -2 114 -31 176 -55 115 -150 199 -264     233 -74 22 -191 20 -260 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 5340 c-146 -22 -272 -119 -338 -258 l-32 -67 0 -1445 0 -1445     22 -55 c46 -111 142 -207 253 -253 l55 -22 1446 0 1445 0 75 37 c134 66 229     196 249 340 5 35 10 303 10 596 0 571 -1 586 -50 612 -39 21 -90 15 -119 -14     l-26 -26 -5 -588 c-5 -579 -5 -588 -27 -628 -28 -52 -90 -108 -139 -125 -32     -12 -277 -14 -1424 -14 l-1385 0 -47 23 c-53 26 -102 77 -127 131 -14 33 -16     164 -16 1421 0 1147 2 1392 14 1424 17 49 73 111 125 139 40 22 49 22 628 27     l588 5 26 26 c29 29 35 80 14 119 -26 49 -40 50 -622 49 -299 -1 -565 -5 -593     -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3663 4223 c-26 -62 -163 -595 -163 -634 0 -50 39 -89 89 -89 39 0     572 137 634 163 20 9 37 20 37 25 0 14 -222 262 -311 347 -100 95 -251 225     -262 225 -4 0 -15 -17 -24 -37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerceEditWhite);
export default __webpack_public_path__ + "static/media/eCommerceEditWhite.877dd9b89453f0b03795fd958711c0cd.svg";
export { ForwardRef as ReactComponent };